// extracted by mini-css-extract-plugin
module.exports = {"container":"PriceWithLocalCurrency_container__86wVi","currency":"PriceWithLocalCurrency_currency__Rbkb1"};